// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__AIWwI","select":"Header_select__1BiQo","clinic":"Header_clinic__3Mh1C"};